"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyIpDocumentSchema = exports.printIpDocumentSchema = exports.ipDocumentTypeEnum = void 0;
const zod_1 = require("zod");
/** IP print & document contracts — ADR-085 Phase 13. */
exports.ipDocumentTypeEnum = zod_1.z.enum([
    'INTERIM_BILL', 'FINAL_BILL', 'DETAILED_BILL', 'SUMMARY_BILL',
    'PACKAGE_STATEMENT', 'INSURANCE_STATEMENT', 'CORPORATE_STATEMENT',
    'DEPOSIT_STATEMENT', 'SETTLEMENT_SUMMARY',
]);
/**
 * Printing takes NO financial input. Every figure is read from the immutable
 * snapshot — a caller-supplied total would be a number the document could not
 * later justify, and this document is the legal one.
 */
exports.printIpDocumentSchema = zod_1.z.object({
    documentType: exports.ipDocumentTypeEnum,
    /** Settlement id, or interim-bill snapshot id, depending on document type. */
    sourceId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().max(500).optional(),
});
exports.verifyIpDocumentSchema = zod_1.z.object({
    /** base64url-encoded QR payload. */
    d: zod_1.z.string().min(1).max(4000),
    /** HMAC signature. */
    t: zod_1.z.string().min(16).max(128),
});
//# sourceMappingURL=ip-document.schema.js.map